import React from 'react';
import PropTypes from 'prop-types';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import './index.css'


class ModularTooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverOpen: props.toggleValue
        };
        this.toggle = this.toggle.bind(this);
    }

    componentDidUpdate(prevProp, prevState) {
        if(prevState.popoverOpen !== this.state.popoverOpen) {
            this.props.callbackPopover()
        }
    }

    toggle() {
        this.setState({
            popoverOpen: !this.state.popoverOpen
        });
    }

    componentDidMount() {
    }

    render() {
        return (
            <Popover
                isOpen={this.state.popoverOpen}
                target={this.props.id}
                toggle={this.toggle}
                hideArrow={true}
                placement={this.props.placement}
                className={`${this.props.class == undefined ? "" : this.props.class} shadow shadow-dark rounded-0`}
            // innerClassName="px-3"
            >
                {
                    <div className={`d-flex flex-row align-items-center justify-content-between ${this.props.modalHeader === false ? '' : 'modal-header-class'}  px-4 ${this.props.customWidthClass ? this.props.customWidthClass : ''}`}>
                        <h6 className="mb-0 py-3 px-3  "><small className="font-weight-bold">{this.props.title}</small></h6>
                        <i className="fa fa-times mb-0 float-right py-2" onClick={this.toggle} style={{ cursor: "pointer" }}></i>
                    </div>
                }

                {
                    this.props.customComponent != undefined ?
                        <div className={`${this.props.customWidthClass ? this.props.customWidthClass : ''} modal-body-class p-3`}>
                            {this.props.customComponent}
                        </div>
                        :
                        <div>
                            Hello
                        </div>
                }
            </Popover>
        )
    }
}

// ModularTooltip.propTypes = {

//   };

//   export default ModularTooltip

// import React from 'react';
// import PropTypes from 'prop-types';
// import {withRouter, NavLink as RouterLink,NavLink } from 'react-router-dom';
// import { Tooltip } from 'reactstrap';
// import './index.css'


//  class ModularTooltip extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             tooltipOpen: false,
//             activeToolTipId: null
//           };
//       }

//     toggleMultiple = (e, id) => {
// 		this.setState({ tooltipOpen: false, activeToolTipId: null }, () => {
// 			this.setState({ tooltipOpen: !this.state.tooltipOpen, activeToolTipId: id }, () => {
// 				if (e.type == 'mouseout') {
// 					this.setState({ tooltipOpen: false })
// 				}
// 			})
// 		})

// 	}    

//     render() {
//         const val1 = this.props.data
//         return (
//             <Tooltip placement="right" 
//                     isOpen={this.state.tooltipOpen && this.state.activeToolTipId == `${val1.name}`.replace(/\s/g, '')} 
//                     target={`TooltipExample${`${val1.name}`.replace(/\s/g, '')}`} toggle={(e) => this.toggleMultiple(e, `${val1.name}`.replace(/\s/g, ''))} 
//                     delay={{ show: 0, hide: 5 }}
//                     hideArrow={true}
//                     innerClassName="tooltip-container-main"
//                     modifiers={{offset:{offset: '-150, -300', enabled: true}}}>
//                     >
//                 <div className="tooltip-container m-0 p-0 shadow-sm border border-dark bg-white">
//                 <div className="tooltip-heder-class p-2">
//                     <p className="mb-0 text-dark font-bold">{val1.name}</p>
//                 </div>
//                 <div className="tooltip-body-class p-2">
//                     <p className="mb-0 text-dark">{val1.discription}</p>
//                 </div>
//                 </div>
//             </Tooltip>
//         )    }
// }


export default ModularTooltip


// WEBPACK FOOTER //
// ./src/_components/common/ModularTooltip/index.js